// Binary flags
export const FileTypeEnumValue = {
  None: 0,

  Photo: 1,
  UserGuide: 2,
};
export const FileTypeEnum = [
  {
    value: FileTypeEnumValue.Photo,
    name: 'Photo',
    labelFrench: 'Pdf',
    labelEnglish: 'Photo',
  },
  {
    value: FileTypeEnumValue.UserGuide,
    name: 'UserGuide',
    labelFrench: "Guide d'utilisation",
    labelEnglish: 'User Guide',
  },
];
